function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from "react";
import classnames from "classnames";
import colors from "styles/colors";
import { ConditionalWrapper } from "utils/react";
import { generateOnKeyDownHandler, getAccessibleButtonColor } from "client/services/accessibility/accessibility-service";
import ButtonArrow from "segments/desktop/core-components/button/button-arrow/button-arrow";
import { StyledButtonComponent } from "./button-component.scss";
// BUTTON SIZES
export const XXS = "xxs";
export const XS = "xs";
export const SM = "sm";
export const MD = "md";
export const LG = "lg";
export const FULL = "full";
// BUTTON COLORS
export const BLUE = "blue";
export const MINT_GREEN = "mint-green";
export const BOLD_BLUE = "bold-blue";
export const WHITE = "white";
export const IRIS = "iris";
class ButtonComponent extends PureComponent {
    getComponentInlineStyles() {
        const { outline, color, textColor } = this.props;
        return {
            color: outline ? colors[color] : textColor
        };
    }
    render() {
        const { children, className, color, size, outline, disabled, isWithArrow, iconRenderer, seoFriendlyUrl, minPadding } = this.props;
        const { isHovered } = this.state;
        const inlineComponentStyles = this.getComponentInlineStyles();
        const accessibleColor = getAccessibleButtonColor(color);
        return /*#__PURE__*/ _jsx(ConditionalWrapper, {
            condition: !!seoFriendlyUrl,
            wrapper: this.linkWrapper,
            children: /*#__PURE__*/ _jsxs(StyledButtonComponent, {
                accessibleColor: accessibleColor,
                className: classnames("button-component", className, size, accessibleColor, {
                    outline,
                    disabled,
                    "with-arrow": isWithArrow,
                    "min-padding": minPadding,
                    "with-left-icon": iconRenderer != null
                }),
                onClick: this.onClick,
                style: inlineComponentStyles,
                onKeyDown: this.onKeyDown,
                tabIndex: disabled ? -1 : 0,
                role: "button",
                onMouseEnter: ()=>this.setState({
                        isHovered: true
                    }),
                onMouseLeave: ()=>this.setState({
                        isHovered: false
                    }),
                "data-button-color": accessibleColor,
                children: [
                    iconRenderer && iconRenderer(),
                    children,
                    isWithArrow && /*#__PURE__*/ _jsx(ButtonArrow, {
                        size: size,
                        hover: isHovered
                    })
                ]
            })
        });
    }
    constructor(props){
        super(props);
        _define_property(this, "onClick", (e)=>{
            const { onClick, disabled } = this.props;
            e === null || e === void 0 ? void 0 : e.target.blur(); //remove focus on mouse click
            if (disabled) return;
            onClick(e);
        });
        _define_property(this, "linkWrapper", (children)=>{
            const { isOpenLinkInNewTab, seoFriendlyUrl } = this.props;
            return /*#__PURE__*/ _jsx("a", {
                href: seoFriendlyUrl,
                target: isOpenLinkInNewTab ? "_blank" : "_self",
                children: children
            });
        });
        this.onKeyDown = generateOnKeyDownHandler(this.onClick);
        this.state = {
            isHovered: false
        };
    }
}
export { ButtonComponent as default };
ButtonComponent.defaultProps = {
    className: "",
    color: BLUE,
    size: MD,
    outline: false,
    textColor: colors["white"],
    iconRenderer: null,
    minPadding: false,
    disabled: false
};
